import { IDs } from '../../helpers/IDs';
import { findSteuerParameter } from '../../bereiche/zusatztools/routinen/findSteuerParameter';
import { getUmrechungsFaktor } from './getUmrechnungsFaktor';

export function processSteuer(data: any) {
    const konfig: any = (data[IDs.ENT_KONFIGURATION] || [])
        .find((item: any) => item.startjahr_datenerfassung);
    const startjahr: number = konfig ? konfig.startjahr_datenerfassung : null;
    const jahrMax: number = +new Date().getFullYear() - 1;
    const jahrMin: number = (startjahr > 1900)
        ? startjahr
        : 2010;

    if (!data[IDs.STEUER_ENERGIE]) {
        data[IDs.STEUER_ENERGIE] = {};
    }

    if (!data[IDs.STEUER_STROM]) {
        data[IDs.STEUER_STROM] = {};
    }

    for (let jahr = jahrMin; jahr <= jahrMax; ++jahr) {
        data[IDs.STEUER_ENERGIE][jahr] = getEnergie(data, jahr);
        data[IDs.STEUER_STROM][jahr] = getStrom(data, jahr);
    }
}

function getEnergie(data: any, jahr: number): any {
    const parameter = findSteuerParameter(data, jahr) || {};
    const kennziffern_jahr = data[IDs.KENNZIFFERN_BERECHNET][jahr] || {};

    const verbrauch_erdgas = kennziffern_jahr.verbrauch_waerme_erdgas_kwh || 0;
    const weitergeleitete_waermemenge_erdgas_kwh = kennziffern_jahr.weitergeleitete_waermemenge_erdgas_kwh || 0;
    const verbrauch_genutzte_erdgas = verbrauch_erdgas - weitergeleitete_waermemenge_erdgas_kwh;
    const steuersatz_erdgas_voll = parameter.steuer_erdgas || 0; // €/MWh
    const steuersatz_erdgas_erm = parameter.steuer_erdgas_erm || 0; // €/MWh
    const steuersatz_erdgas_reduziert = steuersatz_erdgas_voll - steuersatz_erdgas_erm;
    const steuer_erdgas_reduziert = (verbrauch_genutzte_erdgas / 1000) * steuersatz_erdgas_reduziert;
    const steuer_erdgas_voll = (verbrauch_genutzte_erdgas / 1000) * steuersatz_erdgas_voll;
    const entlastung_erdgas = steuer_erdgas_voll - steuer_erdgas_reduziert;

    const verbrauch_hel = kennziffern_jahr.verbrauch_waerme_hel_kwh || 0;
    const weitergeleitete_waermemenge_hel_kwh = kennziffern_jahr.weitergeleitete_waermemenge_hel_kwh || 0;
    const verbrauch_genutzte_hel = verbrauch_hel - weitergeleitete_waermemenge_hel_kwh;
    const umfaktor_hel = getUmrechungsFaktor(data, '', jahr, 'heizoel_leicht');
    const steuersatz_hel_voll = parameter.steuer_hel || 0; // €/1.000l
    const steuersatz_hel_erm = parameter.steuer_hel_erm || 0; // €/1.000l
    // const steuersatz_hel_erm_mwh = steuersatz_hel_erm / umfaktor_hel; // €/MWh
    const steuersatz_hel_reduziert = steuersatz_hel_voll - steuersatz_hel_erm;
    const steuer_hel_reduziert = (verbrauch_genutzte_hel / 1000 / umfaktor_hel) * steuersatz_hel_reduziert;
    const steuer_hel_voll = (verbrauch_genutzte_hel / 1000 / umfaktor_hel) * steuersatz_hel_voll;
    const entlastung_hel = steuer_hel_voll - steuer_hel_reduziert;

    const verbrauch_fluessiggas = kennziffern_jahr.verbrauch_waerme_fluessiggas_kwh || 0;
    const weitergeleitete_waermemenge_fluessiggas_kwh = kennziffern_jahr.weitergeleitete_waermemenge_fluessiggas_kwh || 0;
    const verbrauch_genutzte_fluessiggas = verbrauch_fluessiggas - weitergeleitete_waermemenge_fluessiggas_kwh;
    const umfaktor_fluessiggas = getUmrechungsFaktor(data, '', jahr, 'fluessiggas_kg');
    const steuersatz_fluessiggas_voll = parameter.steuer_fluessiggas || 0; // €/1.000kg
    const steuersatz_fluessiggas_erm = parameter.steuer_fluessiggas_erm || 0; // €/1.000kg
    // const steuersatz_fluessiggas_erm_mwh = steuersatz_fluessiggas_erm / umfaktor_fluessiggas; // €/MWh
    const steuersatz_fluessiggas_reduziert = steuersatz_fluessiggas_voll - steuersatz_fluessiggas_erm;
    const steuer_fluessiggas_reduziert = (verbrauch_genutzte_fluessiggas / 1000 / umfaktor_fluessiggas) * steuersatz_fluessiggas_reduziert;
    const steuer_fluessiggas_voll = (verbrauch_genutzte_fluessiggas / 1000 / umfaktor_fluessiggas) * steuersatz_fluessiggas_voll;
    const entlastung_fluessiggas = steuer_fluessiggas_voll - steuer_fluessiggas_reduziert;

    const selbstbehalt = parameter.selbstbehalt_energie || 0;
    const entlastung_total = entlastung_erdgas + entlastung_fluessiggas + entlastung_hel;
    const erstattung = entlastung_total > selbstbehalt ? entlastung_total - selbstbehalt : 0;

    return {
        erstattung,
        hasParameter: Object.keys(parameter).length > 0,
        entlastung_erdgas,
        entlastung_fluessiggas,
        entlastung_hel,
        selbstbehalt,
        steuer_fluessiggas_reduziert,
        steuersatz_erdgas_reduziert,
        steuersatz_erdgas_erm,
        steuersatz_erdgas_voll,
        steuersatz_fluessiggas_reduziert,
        steuersatz_fluessiggas_erm,
        // steuersatz_fluessiggas_erm_mwh,
        steuersatz_fluessiggas_voll,
        steuersatz_hel_erm,
        // steuersatz_hel_erm_mwh,
        steuersatz_hel_reduziert,
        steuersatz_hel_voll,
        verbrauch_erdgas,
        weitergeleitete_waermemenge_erdgas_kwh,
        verbrauch_genutzte_erdgas,
        verbrauch_fluessiggas,
        weitergeleitete_waermemenge_fluessiggas_kwh,
        verbrauch_genutzte_fluessiggas,
        verbrauch_hel,
        weitergeleitete_waermemenge_hel_kwh,
        verbrauch_genutzte_hel
    };
}

function getStrom(data: any, jahr: number): any {
    const parameter = findSteuerParameter(data, jahr) || {};
    const kennziffern_jahr = data[IDs.KENNZIFFERN_BERECHNET][jahr] || {};
    const stromverbrauch = kennziffern_jahr.verbrauch_strom || 0;
    const stromverbrauch_efahrzeuge = kennziffern_jahr.strom_stromverbrauch_efahrzeuge || 0;
    const weitergeleitete_strommenge_kwh = kennziffern_jahr.strom_weitergeleitete_strommenge_kwh || 0;
    const stromverbrauch_rechnung = stromverbrauch + weitergeleitete_strommenge_kwh;
    const stromverbrauch_beguenstigte = stromverbrauch - stromverbrauch_efahrzeuge;

    const selbstbehalt_strom: number = parameter.selbstbehalt_strom || 0;
    const steuersatz_voll: number = parameter.steuer_strom || 0;
    const steuersatz_erm: number = parameter.steuer_strom_erm || 0;
    const steuersatz_reduziert: number = steuersatz_voll - steuersatz_erm;
    const steuer_verbrauch_reduziert: number = (stromverbrauch_beguenstigte / 1000) * steuersatz_reduziert;
    const steuer_verbrauch_voll: number = (stromverbrauch_beguenstigte / 1000) * steuersatz_voll;
    const steuern_zu_zahlen: number = steuer_verbrauch_reduziert + selbstbehalt_strom;
    // const erstattung: number = steuer_verbrauch_voll - steuern_zu_zahlen;

    // Neue Berechnung
    const entlastungsbetrag = (stromverbrauch_beguenstigte / 1000) * steuersatz_erm;
    const erstattung = entlastungsbetrag >= selbstbehalt_strom ? entlastungsbetrag - selbstbehalt_strom : 0;

    return {
        erstattung,
        entlastungsbetrag,
        hasParameter: Object.keys(parameter).length > 0,
        selbstbehalt_strom,
        steuer_verbrauch_reduziert,
        steuer_verbrauch_voll,
        steuern_zu_zahlen,
        steuersatz_erm,
        steuersatz_reduziert,
        steuersatz_voll,
        stromverbrauch,
        stromverbrauch_efahrzeuge,
        weitergeleitete_strommenge_kwh,
        stromverbrauch_rechnung,
        stromverbrauch_beguenstigte
    };
}
